import { Grid, RadioGroup, Typography } from "@mui/material";
import BaseRadio from "../all-inputs/BaseRadio";
import { useEffect, useState } from "react";

export function BaseRadioGroup({
  label,
  containerGridSize = {
    xs: 12,
    display: "flex",
    flexDirection: "column-reverse",
    alignItems: "flex-end",
    alignContent: "flex-end",
  },
  labelGridSize = { xs: 5 },
  inputGridSize = { xs: 7 },
  disabled,
  onChange = () => {},
  value = "",
  data = [],
  RadioGridsize = { xs: 12 },
  variant = "h1",
  error = "",
}) {
  const [showSubmitError, setShowSubmitError] = useState(
    (!value || value === undefined || value === "") && error !== ""
  );

  useEffect(() => {
    setShowSubmitError((!value || value === undefined || value === "") && error !== "");
  }, [error, value]);

  return (
    <Grid item {...containerGridSize}>
      <Grid item {...inputGridSize}>
        <RadioGroup
          value={value !== undefined ? value : ""}
          onChange={onChange}
          disabled={disabled}
        >
          <Grid container item flexDirection="row-reverse">
            {data.map((type) => (
              <Grid item {...RadioGridsize} key={type.code} width="100%">
                <BaseRadio text={type.name} value={type.code} disabled={disabled} />
              </Grid>
            ))}
          </Grid>
        </RadioGroup>
      </Grid>
      <Grid item {...labelGridSize}>
        <Typography
          variant={variant}
          fontSize="0.6rem"
          color="#FF0000"
          mb={0.7}
          sx={{ direction: "rtl", display: "inline-block" }}
          mr="0.2rem"
        >
          {showSubmitError && `(${error}‌)`}
        </Typography>
        <Typography variant={variant} mb={0.5} display="inline-block">
          {label}
        </Typography>
      </Grid>
    </Grid>
  );
}
